module.exports = __webpack_public_path__ + "static/media/app_store.0713c28f.png";